const getMessageIdentity = message => {
  const isCall = message.type === 3 || message.type === 4
  const identifier = isCall ? (message.callId || message.id) : message.id

  return `${message.youngId}:${isCall ? 'call' : 'message'}:${identifier}`
}

export default getMessageIdentity
